import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Импортирование контрагентов",
    "confirm-button-text": "Импортировать",
    "is-confirm": false,
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.importCompanies
  }, {
    default: _withCtx(() => [
      _createVNode(_component_file_reader, {
        value: _ctx.state.files,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.files) = $event)),
        placeholder: "Выберите Excel файл (.xlsx)",
        accept: ".xlsx",
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.files.$error,
        "validation-errors": _ctx.state_form$.files.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_checkbox, {
        class: "mt-2",
        label: "Активировать все данные",
        value: _ctx.state.is_activated,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.is_activated) = $event)),
        disabled: _ctx.state.is_loading
      }, null, 8, ["value", "disabled"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}